import { sendAnalyticsInfo } from 'features/analytics/helpers';
import { TeamingLogMessages } from 'features/teaming/teaming-base/enums';

export const requestHandoffAnalytics = (methodName: string) => {
  return sendAnalyticsInfo({
    Method: methodName,
    Message: TeamingLogMessages.HANDOFF_BUTTON_CLICKED,
  });
};

export const conferenceChangeAnalytics = (memberCount: number) => {
  return sendAnalyticsInfo({
    Method: 'DHVIConferenceChange',
    Message: `Conference member count changed to ${memberCount}`,
    MemberCount: memberCount,
    LogGroup: 'Teaming',
  });
};
